import { Coins } from 'lucide-react'
import { v2TierFor } from '@renderer/chat/utils/billingUtils'
import { usePaywallState } from '@renderer/chat/store/paywalls'
import { useUnifiedBilling } from '@renderer/chat/store/global-billing'
import { chatCreditsOutCopy, resetDateLabel } from '@renderer/components/pricing/limits-copy'
import { PlanUpgradeButton } from '@renderer/components/pricing/locked-page'
import { PlanNote } from '@renderer/components/pricing/plan-note'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { subscriptionPlansRoute, subscriptionTopUpRoute } from '@shared/settings/settings-deeplink'
import { openSubscriptionSettings } from '@renderer/overlay/Sidepanel/components/sidepanel/plan-banners/sidepanel-plan-banners'

/**
 * A turn refused because the credits are spent: Highlight's reply is the fact
 * and the way on, in the thread where the person is looking. Free is sold Pro;
 * a paid plan buys more credits.
 */
export function CreditsOutReply() {
  const paywall = usePaywallState()
  const { subscription } = useUnifiedBilling()
  const tier = v2TierFor(paywall.plan)
  const plan = tier ?? 'pro2'
  const copy = chatCreditsOutCopy({
    plan: tier ?? 'free',
    upgradeTo: 'pro2',
    resets: resetDateLabel(subscription.currentPeriodEndAt),
  })

  const onAction = () => {
    AmplitudeRenderer.trackEvent('Paywall', {
      action: 'clicked',
      feature: 'credits-out',
      reason: tier ? 'top-up' : 'upgrade',
      plan,
      from: 'chat',
    })
    openSubscriptionSettings(tier ? subscriptionTopUpRoute('credits') : subscriptionPlansRoute())
  }

  return (
    <div className="mt-2 px-5">
      <PlanNote
        className="mb-3"
        icon={<Coins />}
        plan={plan}
        title={copy.title}
        body={copy.body}
        actions={
          <PlanUpgradeButton plan={plan} size="sm" onClick={onAction}>
            {copy.cta}
          </PlanUpgradeButton>
        }
      />
    </div>
  )
}
